import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FormWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
});

export const StyledForm = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
});

export const FormFieldsContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: '0 0.125rem',

  '& .MuiFormControl-root': {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    marginBottom: 0,
    marginTop: 0,
    paddingBottom: '0 !important',
  },

  '& .MuiFormLabel-root, & .MuiFormControl-root > div > p': {
    textTransform: 'none !important' as 'none',
    fontFamily: '"Neue Frutiger World", sans-serif !important',
    fontSize: '0.75rem !important',
    fontStyle: 'normal',
    fontWeight: '400 !important',
    lineHeight: '160%',
    marginBottom: '0 !important',
    color: '#333239 !important',
  },

  '& .MuiInputBase-root:not(.MuiPickersInputBase-root)': {
    height: 'auto',
    minHeight: '2.5rem',
    padding: '0.5rem !important',
    alignItems: 'center',
    gap: '0.5rem',
    borderRadius: '0.75rem',
    backgroundColor: '#F5F5F7',
  },

  '& input, & textarea': {
    padding: '0 !important',
    color: '#615E6F !important',
    fontFamily: '"Neue Frutiger World", sans-serif !important',
    fontSize: '0.75rem !important',
    fontWeight: '400 !important',
    lineHeight: '160% !important',
    opacity: 1,
  },

  '& input::placeholder, & textarea::placeholder': {
    color: '#615E6F !important',
    fontFamily: '"Neue Frutiger World", sans-serif !important',
    fontSize: '0.75rem !important',
    fontWeight: '400 !important',
    lineHeight: '160% !important',
    opacity: 1,
  },

  '& .MuiInputBase-multiline': {
    height: '5.9375rem !important',
    maxHeight: '5.9375rem !important',
    padding: '0.5rem !important',
    alignItems: 'flex-start',
    gap: '0.25rem',
    borderRadius: '0.75rem !important',
    backgroundColor: '#F5F5F7',
    overflow: 'hidden',

    '& textarea': {
      overflow: 'auto !important',
      height: '100% !important',
    },
  },

  '& .MuiAutocomplete-root .MuiInputBase-root': {
    height: '2.5rem',
    padding: '0.5rem !important',
    border: '1px solid rgba(0, 0, 0, 0.15)',
    borderRadius: '0.75rem',

    '& fieldset': { border: 'none !important' },
    '& .MuiInputBase-input': { paddingLeft: '0 !important' },
  },

  '& .MuiAutocomplete-endAdornment': {
    right: '1rem !important',
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
  },

  '& .MuiAutocomplete-clearIndicator': { marginRight: '0.25rem' },

  '& .MuiAutocomplete-popupIndicator': {
    padding: 0,
    width: '1rem',
    height: '1rem',

    '& svg': { display: 'none' },

    '&::after': {
      content: '""',
      display: 'block',
      width: '1rem',
      height: '1rem',
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M13 5.5L8 10.5L3 5.5' stroke='%239EA5AD' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
  },

  '& fieldset': { borderRadius: '0.75rem !important' },
});

export const FormActions = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '0.5rem',
});

export const FormActionsInner = styled(Box)({
  display: 'flex',
  gap: '0.5rem',
  width: '50%',
});
